export { AddNewProductsWrapper } from './src/add-new-products-wrapper';
